import styled from 'styled-components';
import { Typography } from '@mui/material';
import { Flex, FlexColumn } from '../Flex';
import TestAccordion from './TestAccordion';

export const FieldsWrapper = styled(FlexColumn)`
  gap: 24px;
`;

export const NestedFields = styled(FieldsWrapper)`
  border-left: 4px solid ${({ theme }) => theme.palette.common.lightBlue3};
  padding: 8px 24px;
`;

export const FormText = styled(Typography)<{ $muted?: boolean }>`
  color: ${({ $muted, theme }) =>
    $muted ? theme.palette.common.gray2 : theme.palette.common.black};
`;

export const FormTitle = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
`;

export const Row = styled(Flex)`
  align-items: center;
  gap: 16px;
  width: 100%;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: ${({ theme }) => theme.palette.common.gray8};
`;

export const InputWrapper = styled(FlexColumn)`
  position: relative;
`;

export const ErrorMessage = styled(Typography)`
  position: absolute;
  color: ${({ theme }) => theme.palette.common.red} !important;
  font-size: 10px;
  left: 0;
  bottom: -14px;
  line-height: 10px;
  white-space: nowrap;
`;

export const InlineFormContent = styled.div`
  font-size: 14px;

  > span {
    display: inline-block;
    vertical-align: middle;
    margin: 0 8px;
  }
`;

export const SectionTitle = styled(Typography)`
  font-size: 13px;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  line-height: 24px;
  color: ${({ theme }) => theme.palette.common.gray2};
  text-transform: uppercase;
  letter-spacing: 0.39px;
`;

export const SectionDescription = styled(Typography)`
  color: ${({ theme }) => theme.palette.common.gray2};
`;

export const InfoBox = styled.div`
  background-color: ${({ theme }) => theme.palette.common.gray15};
  padding: 16px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.common.black};
`;

export default {
  FieldsWrapper,
  NestedFields,
  FormText,
  FormTitle,
  Row,
  Divider,
  InputWrapper,
  ErrorMessage,
  InlineFormContent,
  TestAccordion,
  SectionTitle,
  SectionDescription,
  InfoBox,
};
